export const LISTE_INDICE_ET_VALEUR = {
  title: 'Liste des indices et valeurs',
  liste: 'Liste indice et valeur',
  actions: {
    add: 'Ajouter un indice',
  },
  tab: {
    libelle: 'Libellé',
    actif: 'Actif',
  },
  childrow: {
    dateReference: 'Date référence',
    valeurIndice: 'Valeur d\'indice',
    trimestre: 'Trimestre',
  },
  popUpDelete: {
    title: 'Êtes-vous sûr de vouloir supprimer cet indice ?',
  },
  messages: {
    success: {
      delete: 'Indice supprimé avec succès.',
      archiver: 'Indice archivé avec succès.',
      desarchiver: 'Indice désarchivé avec succès.',
    },
  },
  popUpArchivage: {
    titleArchiver: 'Êtes-vous sûr de vouloir archiver cet indice ?',
    titleDesarchiver: 'Êtes-vous sûr de vouloir désarchiver cet indice ?',
  },
  filtres: {
    actif: 'Actif',
  },
};

export const ADD_INDICE = {
  titleAdd: 'Ajouter un indice',
  titleEdit: 'Modifier indice {libelle}',
  liste: 'Liste indice et valeur',
  addLigne: 'Ajouter un indice valeur',
  error: {
    problemOccurred: 'Un problème est survenu',
    dateReference: 'Date référence',
    valeurIndice: 'Valeur d\'indice',
  },
  success: {
    add: 'L\'indice a été ajouté avec succès.',
    edit: 'L\'indice a été modifié avec succès.',
  },
  information: {
    libelle: 'Libellé',
    valeurIndice: {
      dateReference: 'Date référence',
      valeurIndice: 'Valeur d\'indice',
      trimestre: 'Trimestre',
    },
  },
};
